/**
 * Function is a reducer to convert 2D array to object.
 *
 * @usage [[id1, value1], [id2, value2]].reduce(mapArrayToObjectReducer, {})
 *
 * @param {Array} value - An array with following structure [[id1, value1], [id2, value2] ...]
 * @returns {Object} - returns an object in format {id1: value1, id2: value2, ...}
 */
export const mapArrayToObjectReducer = (previousValue, currentValue) => {
  return { ...previousValue, [currentValue[0]]: currentValue[1] };
};

/**
 * Function groups objects by a specified property.
 *
 * @param {Array} objArray
 * @param {string} property
 *
 * @returns {Object}
 */
export const groupBy = (objArray, property) => {
  return objArray.reduce((acc, obj) => {
    let key = obj[property];
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(obj);
    return acc;
  }, {});
};
